import React, { Component } from "react";
import "./newqrheader.css";

export default class NewQrHeader extends React.Component {
    render() {
        return (
            <>
                <div className="qr_header_main_wrapper">
                    <div className="row justify-content-start p-0 pt-2">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="row p-0 pb-2 align-items-center">
                                <div className="col-lg-6 col-md-6 col-sm-12"><p>Client :</p></div>
                                <div className="col-lg-6 col-md-6 col-sm-12"><p>Client 12345</p></div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="row p-0 pb-2 align-items-center">
                                <div className="col-lg-6 col-md-6 col-sm-12"><p>Termin :</p></div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <p>07.06.2024, 08:38</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="row p-0 pb-2 align-items-center">
                                <div className="col-lg-6 col-md-6 col-sm-12"><p>Kontrollschild :</p></div>
                                <div className="col-lg-6 col-md-6 col-sm-12"><p>LJ 01-21524</p></div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="row p-0 pb-2 align-items-center">
                                <div className="col-lg-6 col-md-6 col-sm-12"><p>Auftrag Nr :</p></div>
                                <div className="col-lg-6 col-md-6 col-sm-12"><p>21524-001</p></div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="row p-0 pb-2 align-items-center">
                                <div className="col-lg-6 col-md-6 col-sm-12"><p>Fahrzeughalter :</p></div>
                                <div className="col-lg-6 col-md-6 col-sm-12"><p>Löffel Peter</p></div>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-end p-0">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="row p-0 pb-2 align-items-center">
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <div className="d-flex align-items-center">
                                        <p className="d-flex"><span class="icon_box mr-1">&#9744;</span>+41793898963</p>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <div className="d-flex align-items-center">
                                        <p className="d-flex"><span class="icon_box mr-1">&#9744;</span>muster.hans@bluewin.com</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-start p-0">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="row p-0 pb-2">
                                <div className="col-lg-6 col-md-6 col-sm-12"><p>N° de châssis (VIN) :</p></div>
                                <div className="col-lg-6 col-md-6 col-sm-12"><p>WF0AXXWPMAFY73348 </p></div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="row p-0 pb-2">
                                <div className="col-lg-6 col-md-6 col-sm-12"><p>1ère mise en circ :</p></div>
                                <div className="col-lg-6 col-md-6 col-sm-12"><p>14.08.2015</p></div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="row p-0 pb-2">
                                <div className="col-lg-6 col-md-6 col-sm-12"><p>Marque / Modèle :</p></div>
                                <div className="col-lg-6 col-md-6 col-sm-12"><p>Ford / Kuga / 2.0 TDCi 150 Titanium S</p></div>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-start p-0">
                        <div className="col-12 qr-bottom-row">
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
